export default {"src":"/_next/static/media/bsc.ba2d0a87.svg","height":2496,"width":2496,"blurWidth":0,"blurHeight":0};